import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const BlogArticle_Query = graphqlShopifyStorefront(`
query BlogArticle($country: CountryCode, $articleHandle: String!, $blogHandle: String!, $language: LanguageCode) @inContext(country: $country, language: $language) {
  blog(handle: $blogHandle) {
    articleByHandle(handle: $articleHandle) {
      contentHtml
      excerptHtml
      id
      title
    }
  }
}
`);
